module.exports = "/images/move-down.svg?8baf06510967c1fd3b5e6e647d75ac95";